const isFormDirty = ({
  dirty,
  logoFile,
  coverFile,
  logoPreview,
  coverPreview,
  initialLogoUrl,
  initialCoverUrl,
  isInitialized
}) => {
  if (!isInitialized) return false;
  if (dirty) return true;
  if (logoFile || coverFile) return true;
  if (initialLogoUrl && !logoPreview) return true;
  if (initialCoverUrl && !coverPreview) return true;
  return false;
};

export default isFormDirty;
